<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="form-group row">
					<div class="col-lg-12">
						<label for="">Usuario *</label>
						<select v-model="Vendedor.IdUsuario" class="form-control">
							<option value="">Seleccione un Usuario</option>
							<option v-for="(item,index) in ListaVendedores" :key="index" :value="item.IdUsuario">{{item.Nombre}}</option>
						</select>
						 <Cvalidation v-if="this.errorvalidacion.IdUsuario" :Mensaje="errorvalidacion.IdUsuario[0]"></Cvalidation>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-lg-4">
						<label for="">Nombre *</label>
						<input type="text" placeholder="Nombre" v-model="Vendedor.Nombre" class="form-control"/>
						<Cvalidation v-if="this.errorvalidacion.Nombre" :Mensaje="errorvalidacion.Nombre[0]"></Cvalidation>
					</div>
					<div class="col-lg-4">
						<label for="">Teléfono *</label>
						<input type="text" placeholder="Teléfono" v-model="Vendedor.Telefono" class="form-control"/>
						<Cvalidation v-if="this.errorvalidacion.Telefono" :Mensaje="errorvalidacion.Telefono[0]"></Cvalidation>
					</div>
					<div class="col-lg-4">
						<label for="">Email *</label>
						<input type="text" placeholder="Email" v-model="Vendedor.Correo" class="form-control"/>
						<Cvalidation v-if="this.errorvalidacion.Correo" :Mensaje="errorvalidacion.Correo[0]"></Cvalidation>
					</div>
				</div>
			</template>
		</CLoader>
	</div>
</template>

<script>
import Cbtnsave from "@/components/Cbtnsave.vue";
import Cvalidation from "@/components/Cvalidation.vue";
export default {
	name: "Form",
    props: ["IdVendedor", "poBtnSave"],
	data() {
		return {
			Modal: true, //Sirve pra los botones de guardado
            FormName: "vendedor", //Sirve para donde va regresar,
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            ListaVendedores: [],
            Vendedor: {
                IdVendedor: 0,
                IdUsuario: "",
                Nombre: "",
                Correo: "",
                Telefono: "",
            },
            urlApi: "vendedorcotizacion/recovery",
            urlVendedor: "vendedores/get",
            errorvalidacion: [],
		}
	},
	components: {
        Cbtnsave,
        Cvalidation,
    },
	methods: {
		 async Guardar() {
            //deshabilita botones
            this.poBtnSave.toast = 0;
            this.poBtnSave.disableBtn = true;

            let formData = new FormData();

            formData.set("IdVendedor", this.Vendedor.IdVendedor);
            formData.set("Nombre", this.Vendedor.Nombre);
            formData.set("Telefono", this.Vendedor.Telefono);
            formData.set("Correo", this.Vendedor.Correo);
            formData.set("IdUsuario", this.Vendedor.IdUsuario);

            await this.$http.post("vendedorcotizacion/post", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((res) => {
                this.poBtnSave.disableBtn = false;
                this.poBtnSave.toast = 1;

                $("#ModalForm").modal("hide");
                this.bus.$emit("List");
            })
            .catch((err) => {
                this.poBtnSave.disableBtn = false;
                this.errorvalidacion = err.response.data.message.errores;
                this.poBtnSave.toast = 2;
            });
        },
		Limpiar(){
			this.Vendedor={
				IdVendedor: 0,
                IdUsuario: "",
                Nombre: "",
                Correo: "",
                Telefono: "",
			},
			this.errorvalidacion=[];
		},
		get_one() {
            this.$http.get(this.urlApi, {
                    params: { IdVendedor: this.Vendedor.IdVendedor },
            })
            .then((res) => {
                this.Vendedor.IdVendedor = res.data.data.vendedor.IdVendedor;
                this.Vendedor.Nombre = res.data.data.vendedor.Nombre;
                this.Vendedor.Telefono = res.data.data.vendedor.Telefono;
                this.Vendedor.Correo = res.data.data.vendedor.Correo;
                this.Vendedor.IdUsuario = res.data.data.vendedor.IdUsuario;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
				this.GetVendedores();
            });
        },
		GetVendedores() {
            this.$http.get(this.urlVendedor, {
                params: { RegEstatus: "A",Admin:1 },
            })
            .then((res) => {
                let Mapeado=res.data.data.Vendedores.map((Element)=>{
                    if (Element.IdUsuario==null) {
                        Element.IdUsuario=Element.TrabajadorUsuario,
                        Element.Nombre=Element.NombreAdmin
                        return Element;
                    }
                    else{
                        return Element;
                    }
                });
                this.ListaVendedores=Mapeado;
				this.FiltrarVendedores();
            });
        },
		FiltrarVendedores(){
			this.$http.get('vendedorcotizacion/get').then((res)=>{
				let Vendedores=res.data.data.todos.map((value) => {return value.IdUsuario});
				if (this.Vendedor.IdVendedor>0) {
					Vendedores=Vendedores.filter((value) => {
						if (value!=this.Vendedor.IdUsuario) {
							return true;
						}
					})
				}
				let Result=this.ListaVendedores.filter((value) => {
					let Index=Vendedores.findIndex((value2) => value.IdUsuario==value2);
					if (Index==-1) {
						return true;
					}
				});
				this.ListaVendedores=Result;
			})
		}
	},
	created() {
		this.bus.$off("Nuevo");

		this.bus.$on("Nuevo", (data, Id) => {
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn = false;
            this.bus.$off("Save");
            this.bus.$on("Save", () => {
                this.Guardar();
            });

            this.Limpiar();
            if (Id > 0) {
                this.Vendedor.IdVendedor = Id;
                this.get_one();
            }
            else{
				this.GetVendedores();
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$emit("Desbloqueo", false);
        });

        if (this.Id != undefined) {
            this.Vendedor.IdVendedor = this.Id;
            this.get_one();
        }
	},
}
</script>

<style>

</style>
